<script setup lang="ts">
import { CtButton } from '@camelot/components'
import MobileSumm from '~/components/sidebar/mobile/MobileSumm.vue'
import SummaryCoverage from '~/components/sidebar/SummaryCoverage.vue'
import SummaryOptions from '~/components/sidebar/SummaryOptions.vue'
import SummaryVehicle from '~/components/sidebar/SummaryVehicle.vue'
import { useOfferAdditionalOptions } from '~/composables/offer-additional-options'
import { translate } from '~/composables/translate/translations'
import { useExtrasStore } from '~/stores/extras'
import { useLocationStore } from '~/stores/location'

const emits = defineEmits(['closeSheet'])

const extrasStore = useExtrasStore()

const { option: crossBorderOption } = useOfferAdditionalOptions(`cross_border_${useLocationStore().city.country}`, '.')
const { option: comfortOption } = useOfferAdditionalOptions('cleaned', '\n', 'refueled')

const plusCoverageChosen = computed<boolean>(() => extrasStore.propertyChosen(crossBorderOption.value?.id))
const comfortChosen = computed<boolean>(() => extrasStore.propertyChosen(comfortOption.value?.id))
</script>

<template>
  <div class="container flex justify-between">
    <h2 class="pl-24 ct-title-2 inline-block pt-8">
      {{ translate('sidebar_my_booking_title') }}
    </h2>
    <div class="ml-auto">
      <CtButton
        variant="primary"
        type="button"
        size="sm"
        :success="false"
        :error="false"
        :disabled="false"
        :loading="false"
        icon="cross"
        class="self-end mr-8"
        @click="emits('closeSheet')"
      />
    </div>
  </div>
  <ul>
    <li>
      <SummaryVehicle class="border-b-cotton flex-1" />
    </li>
    <li>
      <SummaryCoverage class="border-b-cotton flex-1" />
    </li>
    <li>
      <SummaryOptions v-if="plusCoverageChosen || comfortChosen" class="border-b-4 border-b-cotton flex-1" />
    </li>
    <MobileSumm class="drop-shadow-md shadow-negative" @next-step="emits('closeSheet')" />
  </ul>
</template>
